// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3ZFDHx4ryG","small":"h37PY0HbhQ","large":"_2Qwx7yLPP5","nudgeUp":"_1MVgVzYP5l","nudgeDown":"_2-BI5zisWK"};
    if(module.hot) {
      // 1597843236996
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  